import { render, staticRenderFns } from "./appbanneradvertiserManageEdit.vue?vue&type=template&id=4f7c56eb&scoped=true"
import script from "./appbanneradvertiserManageEdit.vue?vue&type=script&lang=js"
export * from "./appbanneradvertiserManageEdit.vue?vue&type=script&lang=js"
import style0 from "./appbanneradvertiserManageEdit.vue?vue&type=style&index=0&id=4f7c56eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7c56eb",
  null
  
)

export default component.exports